module.exports = __webpack_public_path__ + "static/media/repeat-1-alt.b19e99cf.svg";